<div class="dropdown custom-right-dropdown dropend">
  <button type="button" (click)="onAddVariablesButtonClick(variablesList)"
          class="btn btn-default variables-button ms-1"
          id="emailTitleDropDown"
          [disabled]="isDisabled()">
    {{!hideText() ? 'Variables' : ''}}
  </button>

  <ng-template #variablesList let-modal>
    <app-iframe-modal-shell [src]="variableListUrl" (close)="modal.dismiss('cancel')"></app-iframe-modal-shell>
  </ng-template>
</div>
